<div (click)="onTriggerClick($event)">
  @if (customTriggerTemplateRef()) {
    <ng-container *ngTemplateOutlet="customTriggerTemplateRef()" />
  } @else {
    <ng-container *ngTemplateOutlet="defaultTriggerTemplate" />
  }
</div>

<ng-template #defaultTriggerTemplate>
  <p-button
    size="small"
    severity="secondary"
    pTooltip="Configure Net Return"
    tooltipPosition="left"
  >
    <ng-template #icon>
      <svg-icon src="/assets/icons/general/configuration.svg" />
    </ng-template>
  </p-button>
</ng-template>

<p-popover #granularityPopover>
  <div class="flex flex-col gap-2">
    <p class="font-semibold">Configure Expected Net Return</p>
    <div class="grid auto-cols-auto grid-cols-[auto_1fr] gap-x-2 gap-y-2">
      <div class="contents">
        <span class="flex items-center">Unit:</span>
        <ng-select
          class="min-w-fit"
          [items]="units"
          [closeOnSelect]="true"
          [searchable]="false"
          [clearable]="false"
          [(ngModel)]="granularity().unit"
          placeholder="Select unit..."
          (ngModelChange)="onGranularityChange()"
        />
      </div>
      <div class="contents">
        <span class="flex items-center">Currency:</span>
        <ng-select
          class="min-w-fit"
          [items]="currencies"
          [closeOnSelect]="true"
          [searchable]="true"
          [virtualScroll]="true"
          [clearable]="false"
          [(ngModel)]="granularity().currency"
          placeholder="Select currency..."
          bindValue="currencyCode"
          bindLabel="label"
          (ngModelChange)="onGranularityChange()"
        />
      </div>
      <div class="contents">
        <span class="flex items-center">Incoterm:</span>
        <ng-select
          class="min-w-fit"
          [items]="incoterms"
          [closeOnSelect]="true"
          [searchable]="false"
          [clearable]="false"
          [(ngModel)]="granularity().incoterm"
          placeholder="Select incoterm..."
          (ngModelChange)="onGranularityChange()"
        />
      </div>
      @if (sourcePageHasPriceBreakdown()) {
        <div class="contents" title="Display verbose cost breakdown in tooltip">
          <span class="flex items-center">Cost Breakdown:</span>
          <input
            type="checkbox"
            [(ngModel)]="granularity().verboseBreakdown"
            (ngModelChange)="onGranularityChange()"
          />
        </div>
      }
    </div>
  </div>
</p-popover>
